import axios, { AxiosInstance } from 'axios';

const GENERAL: AxiosInstance = axios.create({});


const ACCESS: AxiosInstance = axios.create({});


const CONFIRM: AxiosInstance = axios.create({});


// // 개발용
// GENERAL.defaults.baseURL =
//   process.env.NODE_ENV === "development" ? "/" : "http://172.105.228.220:5001";

// 빌드용
  GENERAL.defaults.baseURL =
      ACCESS.defaults.baseURL =
      CONFIRM.defaults.baseURL =
          "http://172.105.228.220/api/";

  export default { GENERAL, CONFIRM, ACCESS };